import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { LabeledCreatableSelect, GoogleAutoComplete } from "../widgets";
import { gPrincipalVal } from "../bondPrincipalFieldConfig";
import BondPrincipalFormBody from "./BondPrincipalFormBody";
import { useBondPrincipalScreen } from "../hooks/useBondPrincipalScreen";

/** Shell + map for bond-creation Principals step (thin wrappers compose this). */
export default function BondPrincipalScreen({
  kind,
  data,
  updateData,
  globalData,
  isGuest,
  errors,
  title = "Principals",
  renderExtraBlocks,
  includeAttorneyLawFirmIdInPgFetchDeps = false,
}) {
  const bondScreen = useBondPrincipalScreen({
    kind,
    data,
    updateData,
    globalData,
    isGuest,
    includeAttorneyLawFirmIdInPgFetchDeps,
  });

  const {
    cfg,
    dropdowns,
    handlers,
    nameSuggestion,
    principalCount,
    guardians,
  } = bondScreen;

  const fields = Array.from({ length: principalCount }, (_, i) => (
    <BondPrincipalFormBody
      key={`guardian${i}`}
      index={i}
      guardian={guardians[i] || {}}
      guardians={guardians}
      cfg={cfg}
      keys={cfg.fieldKeys}
      gVal={gPrincipalVal}
      data={data}
      updateData={updateData}
      globalData={globalData}
      errors={errors}
      isGuest={isGuest}
      handlers={handlers}
      nameSuggestion={nameSuggestion}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      {...(renderExtraBlocks ? { renderExtraBlocks } : {})}
      {...dropdowns}
    />
  ));

  return (
    <Box
      className="bg-gray-100 p-6 rounded-lg shadow-md max-w-3xl mx-auto mt-8"
      sx={{ border: "1px solid #e0e0e0" }}
    >
      <Typography variant="h5" className="font-bold mb-4">
        {title}
      </Typography>
      {fields}
    </Box>
  );
}

BondPrincipalScreen.propTypes = {
  kind: PropTypes.oneOf(["va", "trustee", "guardianship", "probate"]).isRequired,
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  isGuest: PropTypes.bool,
  errors: PropTypes.object,
  title: PropTypes.string,
  renderExtraBlocks: PropTypes.func,
  includeAttorneyLawFirmIdInPgFetchDeps: PropTypes.bool,
};

BondPrincipalScreen.defaultProps = {
  data: { guardians: [] },
  isGuest: undefined,
  errors: undefined,
  title: "Principals",
  renderExtraBlocks: undefined,
  includeAttorneyLawFirmIdInPgFetchDeps: false,
};
